import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMathTheta = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		d: "M15.25 10c0 4.556-2.35 8.25-5.25 8.25S4.75 14.556 4.75 10m10.5 0c0-4.556-2.35-8.25-5.25-8.25S4.75 5.444 4.75 10m10.5 0H4.75"
	})]
});
const ForwardRef = forwardRef(SvgMathTheta);
export { ForwardRef as ReactComponent };
